
import React, { useState } from 'react';
import { X, Mail, User, Building2, Loader2, Check, Send, Lock } from 'lucide-react';
import { Gym } from '../types';

interface SuperAdminModalProps {
  onClose: () => void;
  gyms: Gym[];
}

const SuperAdminModal: React.FC<SuperAdminModalProps> = ({ onClose, gyms }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [selectedGymId, setSelectedGymId] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('/api/invite-gym', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, fullName, gymId: selectedGymId })
      });

      if (response.ok) {
        setSuccess(true);
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        const data = await response.json();
        alert('Error: ' + (data.details || data.error));
      }
    } catch (err) {
      alert('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-dark-bg/95 backdrop-blur-xl">
      <div className="glass-card max-w-md w-full p-8 sm:p-10 border-brand/20 relative">
        <button onClick={onClose} className="absolute top-6 right-6 text-white/20 hover:text-white">
          <X size={24} />
        </button>

        <div className="mb-8">
          <h2 className="text-2xl font-display uppercase tracking-tighter text-white">Panel Super Admin</h2>
          <p className="text-brand text-[10px] uppercase tracking-[0.2em] font-bold mt-1">Invitar Nuevo Gimnasio</p>
        </div>

        {success ? (
          <div className="text-center py-10">
            <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mx-auto mb-6">
              <Check size={32} className="text-black" />
            </div>
            <p className="text-white font-bold uppercase tracking-widest">Invitación Enviada</p>
            <p className="text-white/40 text-[10px] mt-2">El perfil ha sido creado y vinculado.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-white/30 uppercase tracking-widest ml-1">Email del Dueño</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-white/20" size={18} />
                <input 
                  required
                  type="email" 
                  className="luxury-input w-full pl-12"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="ejemplo@gym.com"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-bold text-white/30 uppercase tracking-widest ml-1">Contraseña</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-white/20" size={18} />
                <input 
                  required
                  type="password" 
                  className="luxury-input w-full pl-12"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-bold text-white/30 uppercase tracking-widest ml-1">Nombre Completo</label>
              <div className="relative">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 text-white/20" size={18} />
                <input 
                  required
                  type="text" 
                  className="luxury-input w-full pl-12"
                  value={fullName}
                  onChange={e => setFullName(e.target.value)}
                  placeholder="Juan Perez"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-bold text-white/30 uppercase tracking-widest ml-1">Asignar Gimnasio</label>
              <div className="relative">
                <Building2 className="absolute left-4 top-1/2 -translate-y-1/2 text-white/20" size={18} />
                <select 
                  required
                  className="luxury-input w-full pl-12 appearance-none cursor-pointer"
                  value={selectedGymId}
                  onChange={e => setSelectedGymId(e.target.value)}
                >
                  <option value="">Seleccionar Gimnasio...</option>
                  {gyms.map(gym => (
                    <option key={gym.id} value={gym.id}>{gym.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <button 
              type="submit" 
              disabled={loading || !selectedGymId}
              className="brutal-btn w-full flex items-center justify-center gap-3 disabled:opacity-50"
            >
              {loading ? <Loader2 className="animate-spin" size={20} /> : 'Enviar Invitación'}
              {!loading && <Send size={18} />}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default SuperAdminModal;
